// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.questions-container {
    max-width: 800px;
    margin: 0 auto;
    padding: 20px;
    font-family: 'Inter', sans-serif;
  }
  
  .questions-container h1 {
    color: #0047AB;
    margin-bottom: 20px;
  }
  
  .questions-container h2 {
    color: #00C39A;
    margin-top: 30px;
  }
  
  .questions-container p, .questions-container ul {
    color: #333;
    line-height: 1.6;
  }
  
  .questions-container ul {
    padding-left: 20px;
  }`, "",{"version":3,"sources":["webpack://./src/components/Questions.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,cAAc;IACd,aAAa;IACb,gCAAgC;EAClC;;EAEA;IACE,cAAc;IACd,mBAAmB;EACrB;;EAEA;IACE,cAAc;IACd,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA;IACE,kBAAkB;EACpB","sourcesContent":[".questions-container {\n    max-width: 800px;\n    margin: 0 auto;\n    padding: 20px;\n    font-family: 'Inter', sans-serif;\n  }\n  \n  .questions-container h1 {\n    color: #0047AB;\n    margin-bottom: 20px;\n  }\n  \n  .questions-container h2 {\n    color: #00C39A;\n    margin-top: 30px;\n  }\n  \n  .questions-container p, .questions-container ul {\n    color: #333;\n    line-height: 1.6;\n  }\n  \n  .questions-container ul {\n    padding-left: 20px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
